import React, { useState } from 'react';
import { Button} from 'react-bootstrap';
import './Clients.scss';
import Memberships from './components/Memberships/Memberships';
import ClientList from './components/ClientList/ClientList';

const Clients: React.FC = () => {
  const [currentView, setCurrentView] = useState<'clients' | 'memberships' >('clients');

  // Opciones de productos (simulado, reemplazar por fetch real si es necesario)

    // Sólo agregamos un subtítulo debajo del título "Stock"
  const renderHeader = () => {
    const subTitle = currentView === 'clients'
      ? 'Mis Clientes'
      : currentView === 'memberships'
      ? 'Membresias'
      : 'Mermas';

    return (
      <div className="mp-page-header-container">
  
          <h2 className='title'>Fidelización
            {subTitle && <h4 className="subtitle">{subTitle}</h4>}
          </h2>

      </div>
    );
  };

  const renderToogle = () => (
    <div className="mp-button-selector-page-container">
      <div className="mp-button-selector-page-selector">
        <Button
          className={`mp-button-selector-page-button ${currentView === 'clients' ? 'active' : 'inactive'}`}
          variant="none"
          onClick={() => setCurrentView('clients')}
        >
          Clientes
        </Button>
        <Button
          className={`mp-button-selector-page-button ${currentView === 'memberships' ? 'active' : 'inactive'}`}
          variant="none"
          onClick={() => setCurrentView('memberships')}
        >
          Membresías
        </Button>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (currentView) {
      case 'clients':
        return <ClientList />;
      case 'memberships':
        return <Memberships />;
      default:
        return null;
    }
  };

  return (
    <>
        {renderHeader()}
        {renderToogle()}
        {renderContent()}
    </>
  );
};

export default Clients;
